import { ALL_PLANS } from "./constants";

const getDueTime = (inv) => {
  const d = inv?.dueDate;
  if (d == null || d === "") return 0;
  if (typeof d === "number") return d;
  if (d instanceof Date) return d.getTime();
  const ts = new Date(d).getTime();
  return Number.isNaN(ts) ? 0 : ts;
};

/**
 * Latest unpaid invoice whose subscription is a package plan (ALL_PLANS).
 * @param {Record<string, object>|null|undefined} payments
 * @returns {{ invoiceKey: string, invoiceData: object } | null}
 */
export const getLastPendingPackagePlanInvoiceEntry = (payments) => {
  if (!payments || typeof payments !== "object") return null;
  const unpaid = Object.entries(payments)
    .filter(
      ([, inv]) =>
        !inv?.isPaid &&
        inv?.subscription &&
        ALL_PLANS.includes(inv.subscription)
    )
    .sort(([, a], [, b]) => getDueTime(b) - getDueTime(a));
  if (unpaid.length === 0) return null;
  const [invoiceKey, invoiceData] = unpaid[0];
  return { invoiceKey, invoiceData };
};
